import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  Image,
  message,
  Modal,
  Row,
  Steps,
  Typography,
  Upload,
} from "antd";
import { ReactNode, useEffect, useState } from "react";
import { useAddLesson } from "../../../stores/stores";
import {
  ListTypeQuestion,
  ModeQuestion,
  QuestionProgressModeClick,
  QuestionTypeEnum,
  TypeCreateQuestion,
} from "../../../constants";
import { renderQuestionNameByType } from "../../../utils/functionUltils";
import { useDirty } from "../../../contexts/DirtyProvider";
import { QuestionBankData } from "../../../types/question-bank";
import {
  LeftOutlined,
  LoadingOutlined,
  RightOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { searchQuestionBanks } from "../../../service/question-bank";
import useDebounce from "../../../hooks/useDebounce";
import { useNavigate } from "react-router-dom";
import useKeyword from "../../../hooks/useKeyword";
import BankQuestion from "../../../pages/library/bank-question";
import "./index.scss";
import { FileType } from "../../../utils/uploadImage";
import { uploadFileMoodleQuiz } from "../../../service/course-construct";

type Props = {
  open: boolean;
  title: string;
  okText: string;
  closeIcon: boolean;
  modalMode?: string;
  cancelText: string;
  courseBlockGroupIdClick: number;
  icon: ReactNode;
  getAllQuizByUnitId?: () => void;
  closeModal: (value: boolean) => void;
  onSelectQuestionType?: (type: number) => void;
};

export default function AddQuestionCourseModal(props: Props) {
  const { t } = useTranslation();
  const {
    open,
    icon,
    title,
    okText,
    modalMode,
    closeIcon,
    cancelText,
    courseBlockGroupIdClick,
    closeModal,
    getAllQuizByUnitId,
    onSelectQuestionType,
  } = props;
  const navigate = useNavigate();
  const currentCourseBlockGroupId =
    useKeyword("courseBlockGroupIdClick") || courseBlockGroupIdClick;
  const unitId = useKeyword("unitId");
  const mode = useKeyword("mode");
  const blockId = useKeyword("blockId");
  const { setDirty } = useDirty();
  const setTypeQuestionChoose = useAddLesson(
    (state) => state.setTypeQuestionChoose
  );
  const setQuestion = useAddLesson((state) => state.setQuestion);
  const setCurrentQuestionInfo = useAddLesson(
    (state) => state.setCurrentQuestionInfo
  );
  const setModeClick = useAddLesson((state) => state.setModeClick);
  const setQuestionSettingsBe = useAddLesson(
    (state) => state.setQuestionSettingsBe
  );
  const setModeQuestion = useAddLesson((state) => state.setModeQuestion);
  const typeCreateQuestion = useAddLesson((state) => state.typeCreateQuestion);

  const [activeType, setActiveType] = useState(0);
  const [dataListTypeQuestion, setDataListTypeQuestion] =
    useState<any>(ListTypeQuestion);
  const [questionBanks, setQuestionBanks] = useState<QuestionBankData[]>([]);
  const [questionBankSelected, setQuestionBankSelected] = useState<
    number | null
  >(null);
  const [keyword, setKeyword] = useState<string>("");
  const keyWordDebounce = useDebounce(keyword, 300);

  const [loading, setLoading] = useState<boolean>(false);
  const [current, setCurrent] = useState(0);
  const [selectedBank, setSelectedBank] = useState<QuestionBankData[]>([]);

  useEffect(() => {
    const getQuestionBanks = async () => {
      const res = await searchQuestionBanks({
        page: 1,
        size: 50,
        keyword: keyWordDebounce,
        isShared: null,
        canEdit: true,
      });
      setQuestionBanks(res.data.data.content);
    };
    getQuestionBanks();
  }, [keyWordDebounce]);

  useEffect(() => {
    setActiveType(0);
    if (modalMode === "upload") {
      setCurrent(0);
    }
  }, [open]);

  useEffect(() => {
    if (typeCreateQuestion === TypeCreateQuestion.SURVEY) {
      const newDataChooseList = dataListTypeQuestion.filter((x: any) => {
        return x.type !== 4;
      });
      setDataListTypeQuestion(newDataChooseList);
    } else {
      setDataListTypeQuestion(ListTypeQuestion);
    }
  }, [typeCreateQuestion]);

  const confirmCreateQuestion = (type: number) => {
    setActiveType(type);
    onSelectQuestionType?.(type);
    setTypeQuestionChoose(type);
    setModeQuestion(ModeQuestion.CREATE);
    setQuestionSettingsBe({});
    setCurrentQuestionInfo({});
    // setQuestionBankSelected(null);
    setKeyword("");
    setModeClick(QuestionProgressModeClick.INPROGRESS);
    closeModal(true);
    setDirty(true);
    let createAnswers: any[] = [];
    if (type === QuestionTypeEnum.TRUE_OR_FALSE) {
      createAnswers = [
        { content: t("Đúng", "Đúng"), orderNumber: 1, isTrue: false },
        { content: "Sai", orderNumber: 2, isTrue: false },
      ];
    }
    let payload;
    if (typeCreateQuestion === TypeCreateQuestion.COURSEWARE) {
      payload = {
        answers: createAnswers,
        courseBlockGroupId: currentCourseBlockGroupId,
        questionBankId: questionBankSelected,
        orderNumber: 1,
        question: renderQuestionNameByType(type),
        questionValue: renderQuestionNameByType(type),
        type: type,
        settingGeneral: {
          displayScoreCriteria: true,
          fileCapacity: 0,
          fileQuantity: 0,
          haveCorrectAnswer: true,
          isAutoMark: true,
          numberingType: 1,
          requiredAnswer: true,
          showForViewer: true,
          shuffleQuestion: true,
          timeToPlay: 0,
        },
        settingHint: {
          content: "",
          isDisplayInstruction: false,
          schema: "",
          uri: "https://",
        },
        settingPoint: {
          correct: 0,
          incorrect: 0,
          isPerQuiz: false,
        },
        settingResponse: {
          correct: "",
          incorrect: "",
          isDisplayPerResponse: false,
          notYet: "",
        },
      };
    }
    if (typeCreateQuestion === TypeCreateQuestion.SURVEY) {
      payload = {
        orderNumber: 1,
        courseBlockGroupId: currentCourseBlockGroupId,
        type: type,
        question: renderQuestionNameByType(type),
        answers: createAnswers,
        settingGeneral: {
          showForViewer: true,
          requiredAnswer: true,
          numberingType: 1,
          fileCapacity: 0,
          fileQuantity: 0,
        },
      };
    }
    if (payload) {
      // createQuiz(payload);
      setQuestion(payload);
    }
  };

  // const createQuiz = async (dataReq: any) => {
  //   try {
  //     let apiRespone: any;
  //     setQuestion({})
  //     if (
  //       dataReq &&
  //       dataReq.type &&
  //       dataReq.type === QuestionTypeEnum.CONNECT
  //     ) {
  //       apiRespone = await createMoocCourseBlockQuizConnect(dataReq);
  //     } else {
  //       apiRespone = await createMoocCourseBlockQuiz(dataReq);
  //     }
  //     const dataRespone = apiRespone.data;
  //     setModeClick(QuestionProgressModeClick.END);
  //     setCurrentIdQuestionAdd(dataRespone.body.id);
  //     saveToIndexDB("current-course", {
  //       currentId: dataReq.id,
  //       id: dataReq.id,
  //       name: currentCourse.name,
  //       parent: currentParentCourse,
  //     });
  //     onRefreshQuizBlock();
  //     setQuestion(dataRespone.body)
  //   } catch (err: any) {
  //     helpService.errorMessage(err?.message || t("Tạo mới thất bại", "Tạo mới thất bại"));
  //     console.error(err);
  //   } finally {
  //   }
  // };

  const steps = [
    {
      title: t("Chọn ngân hàng", "Chọn ngân hàng"),
      content: (
        <BankQuestion
          selectedMode
          mode={mode}
          unitId={unitId}
          blockId={blockId}
          modalMode={modalMode}
          selectedBank={selectedBank}
          courseBlockGroupIdClick={courseBlockGroupIdClick}
          setSelectedBank={setSelectedBank}
        />
      ),
    },
    {
      title: t("Chọn câu hỏi", "Chọn câu hỏi"),
      content: (
        <div className="list-type-question">
          {dataListTypeQuestion.map((item: any, i: number) => (
            <div className="item-type" key={i + 1}>
              <div className="item-type__title">
                <Typography.Title level={5}>{item.title}</Typography.Title>
              </div>
              <div className="item-type__list">
                <Row gutter={16}>
                  {item.childs.map((itemChild: any, iChild: number) => (
                    <Col span={6} key={iChild + 1}>
                      <div
                        className={`item-type__list__item ${
                          activeType === itemChild.type ? "type-active" : ""
                        } ${itemChild?.disable ? "item-disable" : ""} `}
                        onClick={() => confirmCreateQuestion(itemChild.type)}
                      >
                        <Typography.Paragraph className="title">
                          {itemChild.title}
                        </Typography.Paragraph>
                        <Image
                          preview={false}
                          src={itemChild.image}
                          className="icon"
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          ))}
        </div>
      ),
    },
  ];

  // Step
  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  const handleBeforeUpload = (file: FileType) => {
    const isXMLFile = file.type === "text/xml";
    if (!isXMLFile) {
      message.error(t("Bạn phải tải lên file XML !", "Bạn phải tải lên file XML !"));
    }
    return isXMLFile;
  };

  const handleCustomRequestUpload = async (options: any) => {
    const file = options.file;
    if (file.type === "text/xml") {
      const formData = new FormData();
      formData.append("unitId", Number(unitId).toString());
      formData.append("groupId", currentCourseBlockGroupId?.toString());
      formData.append("questionBankId", selectedBank?.[0]?.id?.toString());
      formData.append("xmlFile", file);
      setLoading(true);
      await uploadFileMoodleQuiz(formData)
        .then((res) => {
          if (res.status === 200) {
            message.success(t("Tải lên thành công", "Tải lên thành công"));
            setLoading(false);
            closeModal(false);
            getAllQuizByUnitId && getAllQuizByUnitId();
          }
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    setQuestionBankSelected(
      selectedBank?.length > 0 ? selectedBank?.[0]?.id : null
    );
  }, [selectedBank]);

  return (
    <Modal
      className="add-type-question-modal select-question-bank-modal"
      title={
        <>
          {icon} <Typography.Title level={5}>{title}</Typography.Title>
        </>
      }
      closeIcon={closeIcon}
      centered
      open={open}
      okText={okText}
      cancelText={cancelText}
      onCancel={() => {
        closeModal(false);
        // setQuestionBankSelected(null);
        setKeyword("");
      }}
      closable={!loading}
      footer={null}
      width={"90vw"}
      height={"90vh"}
      style={{ top: 10 }}
      maskClosable={false}
    >
      <section className={`list-type-question ${loading ? "loading-xml" : ""}`}>
        {modalMode === "upload" ? null : (
          <Steps current={current} items={items} />
        )}
        <div className="step-body">
          <div className="step-body__bank">
            {selectedBank.length === 0 ? null : (
              <>
                {t("Ngân hàng:", "Ngân hàng:")}{" "}
                <span style={{ fontStyle: "italic" }}>
                  {selectedBank?.[0]?.name}
                </span>
              </>
            )}
          </div>
          <div className="step-body__content">{steps[current].content}</div>
        </div>
        <div className="step-footer">
          {current < steps.length - 1 && modalMode === "select" && (
            <Button
              disabled={selectedBank.length === 0}
              type="primary"
              onClick={() => next()}
              icon={<RightOutlined />}
              iconPosition="end"
            >
              {t("Tiếp", "Tiếp")}
            </Button>
          )}
          {modalMode === "upload" && (
            <Upload
              showUploadList={false}
              accept=".xml"
              beforeUpload={handleBeforeUpload}
              customRequest={(options) => handleCustomRequestUpload(options)}
            >
              <Button
                className="w-full btn-primary"
                icon={loading ? <LoadingOutlined /> : <UploadOutlined />}
                disabled={selectedBank.length === 0 || loading}
              >
                {t("Tải file", "Tải file")}
              </Button>
            </Upload>
          )}
          {current > 0 && (
            <>
              <Button
                type="default"
                onClick={() => prev()}
                icon={<LeftOutlined />}
                className="mr-2"
                disabled={loading}
              >
                {t("Quay lại", "Quay lại")}
              </Button>
            </>
          )}
        </div>
      </section>
    </Modal>
  );
}
